import { Toaster as Sonner } from 'sonner';

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-black/90 group-[.toaster]:border-white/10 group-[.toaster]:text-white group-[.toaster]:shadow-lg backdrop-blur-xl',
          description: 'group-[.toast]:text-zinc-400',
          actionButton:
            'group-[.toast]:bg-gradient-to-r group-[.toast]:from-yellow-400 group-[.toast]:to-yellow-600 group-[.toast]:text-black',
          cancelButton:
            'group-[.toast]:bg-white/10 group-[.toast]:text-white',
          success: 'group-[.toast]:border-success/50',
          error: 'group-[.toast]:border-destructive/50'
        }
      }}
      {...props}
    />
  );
};

export { Toaster };